import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NewsService } from './news.service';
import { NewsDto } from 'src/app/models/news/news-dto.model';
import { DateFormatterService } from '../../services/utilities/date-formatter.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  animations: [
    trigger('fadeInAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.5s', style({ opacity: 1 }))
      ])
    ]),
    trigger('imageAnimation', [
      transition(':enter', [
        style({ transform: 'scale(0.9)' }),
        animate('0.5s', style({ transform: 'scale(1)' }))
      ])
    ])
  ]
})
export class NewsComponent implements OnInit {
  articles: NewsDto[] = [];
  filteredArticles: NewsDto[]= [];
  displayedArticles: NewsDto[] = [];
  selectedArticle: NewsDto;
  currentPage: number = 1;
  pageSize: number = 4;
  selectedCategory: string;
  totalPages: number;
  categories: string[]= [];

  constructor(
    private newsService: NewsService,
    private dateFormatterService: DateFormatterService,
    private sanitizer: DomSanitizer
  ) { }

    ngOnInit(): void {
    this.newsService.getArticles().subscribe({
      next: (data) => {
        this.articles = Array.isArray(data) ? data : [];
        this.categories = this.getUniqueCategories();
        this.selectedCategory = this.categories[0] ?? '';
        this.filterArticles();
      },
      error: () => {
        this.articles = [];
        this.categories = [];
        this.filteredArticles = [];
        this.displayedArticles = [];
        this.totalPages = 0;
      }
    });
  }

  selectArticle(article: NewsDto): void {
    this.selectedArticle = article;
  }

  clearSelection(): void {
    this.selectedArticle = null;
  }

  getUniqueCategories(): string[] {
    return [...new Set(
      this.articles
        .map(article => article.newsCategoryName)
        .filter(name => !!name)
    )];
  }

  filterArticles(): void {
    this.filteredArticles = this.selectedCategory
      ? this.articles.filter(article => article.newsCategoryName === this.selectedCategory)
      : this.articles;
    this.currentPage = 1; 
    this.totalPages = Math.ceil(this.filteredArticles.length / this.pageSize) || 1;
    this.updateDisplayedArticles();
  }

  updateDisplayedArticles(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.displayedArticles = this.filteredArticles.slice(start, end);
  }

  changePage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updateDisplayedArticles();
    }
  }

  changeCategory(category: string): void {
    this.selectedCategory = category;
    this.filterArticles();
  }

  getHeader(header: string): string {
    if (!header) {
      return '';
    }
    return header.replace('العنوان:', '').replace('العنوان :', '');
  }

  getSummary(details: string): string {
    if (!details) {
      return '';
    }
    const text = details
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return text.length > 220 ? text.slice(0, 220) + '…' : text;
  }

  getSafeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html || '');
  }

  

  getDisplayedPages(): number[] {
    const totalPages = this.totalPages;
    const currentPage = this.currentPage;
    const maxPagesToShow = 3;
    let startPage = Math.max(currentPage - Math.floor(maxPagesToShow / 2), 1);
    let endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(endPage - maxPagesToShow + 1, 1);
    }

    return Array.from({ length: (endPage - startPage + 1) }, (_, i) => startPage + i);
  }
}
